import Link from "next/link";
import { Image } from "shared/components/atoms/Image";
import LineIcon from "@assets/icons/LINE_Brand_icon.svg";

interface Props {
  href: string;
  className?: string;
}

export const CTVRButton = ({ href }: Props) => {
  return (
    <Link href={href} passHref>
      <a
        tw="bg-white w-full h-16 rounded-full flex-center flex-col relative reflective after:reflection"
        css={{ boxShadow: "0px 8px 8px -2px rgba(0, 0, 0, 0.4)" }}
      >
        <span tw="font-base text-lg leading-none text-[#070707] tracking-[3.11px] inline-block ml-4 mt-2.5">
          {`今すぐ無料で占う >`}
        </span>
        <span tw="font-semibold text-line text-2xs">
          <LineIcon tw="inline" css={{ transform: "scale(.5)" }} />
          無料占い結果はLINEで受け取れます
        </span>
        <Image
          tw="w-[58px] absolute -top-0.5 -left-1"
          src="https://cdn.miror.jp/item/free_label.png"
          width={120}
          height={132}
          layout="responsive"
        />
      </a>
    </Link>
  );
};
